import {utils} from '@wallaby-ui/core';

import {LIST_REDUCER_STATE_ID} from './list_constants';
import {listSlice} from './list_slice';
import {AllowedListReducerStateIds} from './list_types';
import {
  filterAndSearchSlice,
  FILTER_AND_SEARCH_REDUCER_STATE_ID,
} from 'src/js/containers/filter_and_search';
import {
  FILTERING_REDUCER_STATE_ID,
  reducer as filtering,
} from 'src/js/containers/filtering';

export const getReducers = (key?: AllowedListReducerStateIds) => ({
  [utils.reducerUtils.getInstanceReducerId(
    FILTER_AND_SEARCH_REDUCER_STATE_ID,
    key
  )]: utils.reducerUtils.createFilteredReducer(
    filterAndSearchSlice.reducer,
    (action) =>
      (action.stateId ?? action.meta?.stateId) ===
      utils.reducerUtils.getInstanceReducerId(
        FILTER_AND_SEARCH_REDUCER_STATE_ID,
        key
      )
  ),
  [utils.reducerUtils.getInstanceReducerId(FILTERING_REDUCER_STATE_ID, key)]:
    utils.reducerUtils.createFilteredReducer(
      filtering,
      (action) =>
        action.stateId ===
        utils.reducerUtils.getInstanceReducerId(FILTERING_REDUCER_STATE_ID, key)
    ),
  [utils.reducerUtils.getInstanceReducerId(LIST_REDUCER_STATE_ID, key)]:
    utils.reducerUtils.createFilteredReducer(
      listSlice.reducer,
      (action) =>
        (action.stateId ?? action.meta?.stateId) ===
          utils.reducerUtils.getInstanceReducerId(LIST_REDUCER_STATE_ID, key) ||
        (action.stateId ?? action.meta?.stateId) ===
          utils.reducerUtils.getInstanceReducerId(
            FILTER_AND_SEARCH_REDUCER_STATE_ID,
            key
          )
    ),
});
